import type { TemplateConfig, FormField } from '../types/templates';
import { CreativityType } from '../types/banner';
import { DISNEY_TEMPLATES } from './DISNEY';
import { RESUMIDO_TEMPLATES } from './RESUMIDO';
import { TEST_TEMPLATES } from './TEST';
import { GPOVALLAS_TEMPLATES } from './GPOVALLAS';
import { MACRO_TEMPLATES } from './MACRO';
import { GVAZ_TEMPLATES } from './GVAZ';
import { HIPOTECARIO_TEMPLATES } from './HIPOTECARIO';

const TEMPLATE_REGISTRY: TemplateConfig[] = [
  ...DISNEY_TEMPLATES,
  ...RESUMIDO_TEMPLATES,
  ...TEST_TEMPLATES,
  ...GPOVALLAS_TEMPLATES,
  ...MACRO_TEMPLATES,
  ...GVAZ_TEMPLATES,
  ...HIPOTECARIO_TEMPLATES
];

export const getCreativityOptions = (clientId: string): TemplateConfig[] =>
  TEMPLATE_REGISTRY.filter(t => t.clientId === clientId && !t.hiddenFromUI);

export const getCreativityForms = (clientId: string) =>
  getCreativityOptions(clientId).reduce(
    (acc, template) => {
      acc[template.id] = {
        title: template.title,
        fields: [...template.formFields] as FormField[],
        templateFamily: template.templateFamily
      };
      return acc;
    },
    {} as Record<string, { title: string; fields: FormField[]; templateFamily?: string }>
  );

// Exact id match first, then longest-id substring fallback.
export const getTemplateByBannerType = (bannerType: string): TemplateConfig | undefined => {
  if (!bannerType) return undefined;

  const exact = TEMPLATE_REGISTRY.find(t => t.id === bannerType);
  if (exact) return exact;

  const matches = TEMPLATE_REGISTRY.filter(t => bannerType.startsWith(t.id) || bannerType.includes(t.id));
  if (matches.length === 0) return undefined;

  return matches.reduce((longest, current) => (current.id.length > longest.id.length ? current : longest));
};

export const isValidCreativityType = (type: string): type is CreativityType =>
  TEMPLATE_REGISTRY.some(t => !t.hiddenFromUI && t.id === type);

export const getHandlerKeyForTemplate = (templateId: CreativityType): string | null =>
  getTemplateByBannerType(templateId)?.handlerKey ?? null;
